<template>
  <div class="content">
      <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>质量安全</el-breadcrumb-item>
            <el-breadcrumb-item>安全管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <div class="build-CURD">
      <div class="build-bar">
        <el-col :span="12" style="text-align: left;padding-left: 20px;display: flex;">
          <el-button-group style="margin-right:10px;">
            <el-button class="head-type" :class="{headCur:head.timeType==1}" @click="changType(1)">日</el-button>
            <el-button class="head-type" :class="{headCur:head.timeType==2}" @click="changType(2)">周</el-button>
            <el-button class="head-type" :class="{headCur:head.timeType==3}" @click="changType(3)">月</el-button>
          </el-button-group>
          <el-date-picker
            v-if="head.timeType==1"
            v-model="head.time1"
            value-format="yyyy-MM-dd"
            type="date"
            @change="timeChange"
            placeholder="选择日期">
          </el-date-picker>
          <el-date-picker
            v-else-if="head.timeType==2"
            v-model="head.time2"
            value-format="yyyy-MM-dd"
            type="week"
            format="yyyy 第 WW 周"
            @change="timeChange"
            placeholder="选择周">
          </el-date-picker>
          <el-date-picker
            v-else-if="head.timeType==3"
            v-model="head.time3"
            value-format="yyyy-MM"
            type="month"
            @change="timeChange"
            placeholder="选择月">
          </el-date-picker>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <a style="color:#ffbc01" @click="doFile(1)">未处理 <p>{{num.wcl}}</p> </a>
          <a style="color:#36c635" @click="doFile(2)">已处理 <p>{{num.ycl}}</p> </a>
          <a style="color:#17b2fe" @click="doFile(3)">已确认 <p>{{num.ysh}}</p> </a>
          <a style="color:#f12b2c" @click="doFile(4)">已超时 <p>{{num.ycs}}</p> </a>
        </el-col>
      </div>
      <div class="build-table">
        <el-table :data="tableData" style="width: 100%">
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
             <el-table-column label="项目名称">
            <template slot-scope="scope">
              <span>{{scope.row.projectName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="巡查事项">
            <template slot-scope="scope">
              <span>{{ scope.row.description }}</span>
            </template>
          </el-table-column>
          <el-table-column label="巡查人">
            <template slot-scope="scope">
              <span>{{ scope.row.reportName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="巡查时间">
            <template slot-scope="scope">
              <span>{{ scope.row.reportDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="处理人">
            <template slot-scope="scope">
              <span>{{ scope.row.handlerName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="现场图片">
            <template slot-scope="scope">
                 <el-image v-if="scope.row.picUrls[0]"
                      style="width: 50px; height: 50px"
                      :src="scope.row.picUrls[0]"
                      :preview-src-list="scope.row.imageList"
               ></el-image>
               <span v-else>暂无图片</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini" @click="addFun(scope.$index, scope.row)">导出</el-button>
            </template>
          </el-table-column>
          <!-- 编辑窗口 -->
          <!-- <el-dialog
            title="编辑"
            :visible.sync="editFormVisible"
            center
            :append-to-body="true"
            :before-close="handleClose"
            :lock-scroll="false"
            width="30%"
          >
            <el-form :model="editForm" ref="editForm">
              <el-form-item label="名称：">
                <el-input v-model="editForm.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="楼号：">
                <el-input v-model="editForm.type" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="类型：">
                <el-input v-model="editForm.adddress" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="所属：">
                <el-input v-model="editForm.people" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="人数：">
                <el-input v-model="editForm.contract" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
          </el-dialog> -->
        </el-table>
        <!-- 分页展示 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[3, 5, 10,20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import myHttp from "../../untils/port.js";
import util from "../../untils/util.js"
import base from '../../untils/base'
export default {
  data() {
    return {
      head:{
        timeType:1,//时间类型  1：日    2：周    3：月
        time1:util.myTime.getCurTime(),
        time2:util.myTime.getWeekDay(0),
        time3:util.myTime.getCurMonth(),
        startDate:'',
        endDate:'',
        flag:'', 
      
      },
      num:{
        wcl:0,
        ycl:0,
        ysh:0,
        ycs:0
      },
      tableData:[],//获取数据
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      projectId:'',
      dataText:"数据加载中...",
        type:'2'
    }
  },
  mounted(){

    this.projectId =  util.session.get('groupId');
    if(this.projectId==""){
      this.$store.commit("setGroupId");
      this.projectId = this.$store.state.groupId;
    }
    this.getData();
  },
  methods: {
    //获取数量
    getNum(){
      var that = this;
      myHttp.getQsStatusCountByEntIdAndJoinType({
        entId:this.projectId,
        type:'2',
        startTime:this.head.startDate,
        endTime:this.head.endDate,
        joinType:'2',
        flag:this.head.flag
      }).then(function(resp){
        if(resp.data.code=="200"){
          that.num = resp.data.data.statusCount||that.num;
        }
      });
    },
    //时间类型修改
    changType(index){
      if(this.head.timeType != index){
        this.head.timeType = index;
        this.getData();
      }
    },
    //时间改变
    timeChange(){
      this.getData();
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage();
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData();
    },
    //获取数据
    getData(){
      if(this.head.timeType==1){
        this.head.startDate = this.head.time1;
        this.head.endDate = this.head.time1;
      }else if(this.head.timeType==2){
        this.head.startDate = this.head.time2;
        this.head.endDate = util.myTime.getWeekDay(6,this.head.time2);
      }else if(this.head.timeType==3){
        this.head.startDate = this.head.time3+'-01';
        var day = new Date(parseInt(this.head.time3.split('-')[0]),parseInt(this.head.time3.split('-')[1]),0).getDate();
        this.head.endDate = this.head.time3+'-'+day;
      }
      this.getNum();
      var that = this;
      myHttp.getQsPageListByEntIdAndJoinType({
        entId:this.projectId,
        type:'2',
        startTime:this.head.startDate,
        endTime:this.head.endDate,
        flag:this.head.flag,
        pageSize:this.pageSize,
        pageNum:this.currentPage,
        joinType:'2'
      }).then(function(resp){
        if(resp.data.code=="200"){
          var list = resp.data.data.pageInfo.list||[];
          for(var i=0;i<list.length;i++){
              list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
              list[i].picUrls=list[i].picUrls == ''?"":list[i].picUrls.split(',')
              for(var j=0;j<list[i].picUrls.length;j++){
                list[i].picUrls[j] = base.httpCtx+list[i].picUrls[j]
              }
              list[i].imageList =list[i].picUrls == ''? []: list[i].picUrls
            }
          that.tableData = list;
          that.totalItems = resp.data.data.pageInfo.total||0;
          if(that.tableData.length==0){
              that.dataText='暂无数据'
            }
        }else{
          that.$message.error(resp.data.msg);
          that.dataText='暂无数据'
        }
      });
    },
    // 编辑数据
    handleEdit(index, row) {
      console.log(111)
      this.$router.push({ name: 'qsDetailCom', params: { id: row.id ,type:this.type} })
    },
    doFile(flag){
     this.head.flag=flag
     this.getData()
    },
    // 导出
    addFun(index, row){
      // exportQsInfo
      var token = this.$store.state.token
      // console.log(projectType)
      window.open(
        myHttp.exportQsInfo +
          '?id=' +
          row.id +
          '&accessToken=' +
          token
      )
    },
  }
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.content {
  padding: 1vh;
}
/* .el-breadcrumb {
  line-height: 30px;
  margin-bottom: 20px;
}
.buildItem {
  font-weight: 0;
  font-size: 24px;
} */
.build-CURD {
  height: 100%;
  background-color: #fff;
}
.build-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 8vh;
  /* border-top: 3px solid rgb(224, 224, 224); */
  border-bottom: 3px solid #f5f5f5;
}
.build-bar span {
  margin-left: 30px;
  margin-right: 20px;
  white-space: nowrap;
  font-weight: bold;
}
.build-bar a {
  display: inline-block;
  white-space: nowrap;
  font-size: 17px;
  cursor: pointer;
}
.build-bar a p {
  display: inline-block;
  margin-left: 10px;
  margin-right: 40px;
}
.build-bar > .el-input {
  margin-left: 50px;
  width: 400px;
}
.build-bar > .el-button {
  margin-left: 20px;
  background-color: #17b2fe;
  border-color: #17b2fe;
}
.build-bar > .el-button + .el-button {
  margin-left: 800px;
}
.el-select .el-input {
  width: 130px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.build-table {
  position: relative;
  width: 94%;
  margin: 0 auto;
  height: calc( 100% - 8vh );
}
.el-table .el-table-column:not(:first-child) {
  border: 1px solid slategrey;
}
.el-table >>> .cell {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
.el-dialog {
  width: 400px;
}
.el-pagination {
  padding: 20px 0;
}
.head-type{
  color: #17b2fe;
}
.el-button-group>.headCur{
  color: #fff;
  background: #17b2fe;
}
.head-type{
  color: #17b2fe;
  width: 98px;
  height: 40px;
}
.el-button-group>.headCur{
  color: #fff;
  background: #17b2fe;
}
</style>
<style>
  .head-type span{
    margin-left:0 !important;
  }
  @import '../../assets/css/common.css'
</style>